import {
  BUNNY_CDN_1_PROD,
  BUNNY_CDN_1_TEST,
  BUNNY_CDN_2_PROD,
  BUNNY_CDN_2_TEST,
  WAVE_PROD,
  WAVE_TEST
} from '@anm/constants/domains';

type GetCloudfrontCdnProps = {
  url: string;
  isLogged: boolean;
};

const getCloudfrontCdn = ({ url, isLogged }: GetCloudfrontCdnProps) => {
  if (!isLogged || url.startsWith('https://wave')) return url;

  return url
    .replace(BUNNY_CDN_1_TEST, WAVE_TEST)
    .replace(BUNNY_CDN_2_TEST, WAVE_TEST)
    .replace(BUNNY_CDN_1_PROD, WAVE_PROD)
    .replace(BUNNY_CDN_2_PROD, WAVE_PROD);
};

export default getCloudfrontCdn;
